define('views/BaseView',['require','exports','module','lodash','jquery','backbone','app','helpers/viewHelpers'],function (require, exports, module) {
  "use strict";

  var _ = require("lodash");
  var $ = require("jquery");
  var Backbone = require("backbone");
  var app = require("app");
  var viewHelpers = require("helpers/viewHelpers");

  var trim = String.prototype.trim ?
    _.bind(String.prototype.trim.call, String.prototype.trim) :
    $.trim;

  var BaseView = Backbone.Layout.extend({
    afterRender: function () {
      app.i18n(this.el);
      $.tagManager({
        where: this.el
      });
    },
    renderTemplate: function (template, context) {
      _.extend(context, viewHelpers);
      return trim(template.call(this, context));
    }
  });

  module.exports = BaseView;
});

